module.exports = __webpack_public_path__ + "8ae1d71b24506e708fa93382103b736e.jpg";